module.exports = __webpack_public_path__ + "25b5c910.svg";